<div class="error-info" *ngIf="error; else accountTypesList">
  {{ error }}
</div>

<ng-template #accountTypesList>
  <mat-card>
    <mat-card-title translate="parameters/accounts/add-account/title"></mat-card-title>
    <mat-card-subtitle [innerHTML]="descriptionLabel"> </mat-card-subtitle>
    <mat-card-content>
      <mat-card
        class="strategy-card"
        *ngFor="let strategy of strategies"
        [class.disabled]="(strategy.disable && strategy.disable()) || !strategy.clickAction"
        [matTooltipDisabled]="!(strategy.disable && strategy.disable()) && strategy.clickAction"
        [matTooltip]="strategy.tooltip"
        (click)="strategy.clickAction && strategy.clickAction()">
        <img [src]="'assets/img/site_icon/v2/' + (strategy.icon || strategy.type) + '.png'" />
        <div>
          <div class="strategy-name" [innerHTML]="strategy.label"></div>
        </div>
      </mat-card>
    </mat-card-content>
  </mat-card>
</ng-template>
